import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListTransporter({
    loading,
    filteredTransporters,
    selected,
    setSelected,
    handleToggleStatus,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
                <thead className="table-light">
                    <tr>
                        <th>Select</th>
                        <th>Transporter Name</th>
                        <th>Transporter Code</th>
                        <th>Contact FirstName</th>
                        <th>Contact LastName</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Address</th>
                        <th>Country</th>
                        <th>State</th>
                        <th>District</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="12" className="text-center py-4">
                                <Loading />
                            </td>
                        </tr>
                    ) : filteredTransporters.length > 0 ? (
                        filteredTransporters.map((t) => {
                            const isInactive = t.status !== "Active";

                            return (
                                <tr key={t.id} className={isInactive ? "table-secondary" : ""}>
                                    <td>
                                        <input
                                            type="radio"
                                            name="transporterSelect"
                                            checked={selected?.id === t.id}
                                            onChange={() => setSelected(t)}
                                            disabled={t.status !== "Active"}
                                        />
                                    </td>
                                    <td>{t.transporterName}</td>
                                    <td>{t.transporterCode}</td>
                                    <td>{t.contactFirstName}</td>
                                    <td>{t.contactLastName}</td>
                                    <td>{t.emailId}</td>
                                    <td>{t.mobileNo}</td>
                                    <td>{t.address}</td>
                                    <td>{t.countryName}</td>
                                    <td>{t.stateName}</td>
                                    <td>{t.cityName}</td>
                                    <td>
                                        <span
                                            className={`badge ${t.status === "Active" ? "bg-success" : "bg-secondary"
                                                }`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleToggleStatus(t.id)}
                                        >
                                            {t.status}
                                        </span>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="12" className="text-center py-3">
                                No Transporters found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
